
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { validateTaxNumber, validateEmail } from '@/tools/regexp';
import {
  saveInvoice,
  invoiceList,
  searchInvoiceName,
  searchInvoiceNo,
  pageVisit,
  getDataInvoice
} from '@/services/http';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Price,
    Footer,
    DropDown,
    NavMenu
  }
})
export default class extends Vue {
  form: any = {
    id: '',
    // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
    invoiceType: 1,
    invoiceName: '',
    invoiceNo: '',
    telephone: '',
    equip: '',
    version: '',
    companyId: 1,
    email: ''
  }

  loading: boolean = false

  companyList: [] = []

  rules: object = {
    invoiceName: [{ required: true, message: '请填写名称', trigger: 'blur' }],
    telephone: [{ required: true, message: '请填写电话号码', trigger: 'blur' }],
    invoiceNo: [{ required: true, validator: validateTaxNumber, trigger: 'blur' }],
    email: [{ required: true, validator: validateEmail, trigger: 'blur' }]
  }

  options: any[] = []

  created() {
    this.setInvoice();
    this.pageVisit();
  }

  selectType(status: number, type?: string) {
    if (!(status === 2 && this.form.invoiceType === 3 && type)) {
      this.form.invoiceType = status;
      const form = this.$refs.form as any;
      form.clearValidate();
    }
  }

  // 模糊搜索公司
  private async searchCompany(queryString: string, cb: any) {
    this.loading = true;
    const res: any = await searchInvoiceName({
      name: queryString
    });
    if (res.data.code === 100) {
      const arr = res.data.data.map((element: any) => ({
        id: element.id,
        value: element.entname
      }));
      cb(arr);
    }
    this.loading = false;
  }

  // 根据公司名称查询税号
  private async searchNo(item: any) {
    const res: any = await searchInvoiceNo({ id: item.id });
    this.form.invoiceNo = res.data.data.taxNumber;
  }

  private async setInvoice() {
    const ID = this.$route.query.id;
    if (ID) {
      const res: any = await invoiceList({ pageNo: 1, pageSize: 40, companyId: 1 });
      const obj = res.data.data.filter((e: any) => e.id === Number(ID))[0];
      this.form = obj;
    }
  }

  // 保存发票信息
  private async saveInvoice() {
    const anchor = readCookie('anchor');
    const form = this.$refs.form as any;
    if (this.form.invoiceType === 1) {
      this.form = {
        id: this.form.id,
        invoiceType: 1,
        invoiceName: this.form.invoiceName,
        telephone: this.form.telephone,
        email: this.form.email,
        equip: '',
        version: '',
        invoiceNo: '',
        companyAddress: '',
        bankNo: '',
        bank: '',
        companyId: 1
      };
    } else if (this.form.invoiceType === 2 || this.form.invoiceType === 3) {
      this.form = {
        id: this.form.id,
        // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
        invoiceType: this.form.invoiceType,
        invoiceName: this.form.invoiceName,
        invoiceNo: this.form.invoiceNo,
        email: this.form.email,
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        companyId: 1
      };
    }
    form.validate(async (valid: boolean) => {
      if (valid) {
        const res: any = await saveInvoice(this.form);
        if (res.data.code === 100) {
          getDataInvoice({
            src: anchor ? (anchor.src ? anchor.src : 2) : 4,
            equip: anchor ? anchor.equip : 4,
            version: anchor ? anchor.version : '',
            model: anchor ? anchor.model : '',
            equipVersion: anchor ? anchor.equipVersion : '',
            equipMeid: anchor ? anchor.equipMeid : '',
            eventNo: '3.3.1.0.0.0.1',
            invoiceType: this.form.invoiceType === 1 ? 1 : 2,
            companyId: 1
          });
          this.$message.success('保存成功！');
          this.$router.back();
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }

  // 访问页面数据埋点
  private pageVisit() {
    const anchor = readCookie('anchor');
    pageVisit({
      pageType: 14,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      model: anchor ? anchor.model : '',
      equipVersion: anchor ? anchor.equipVersion : '',
      equipMeid: anchor ? anchor.equipMeid : '',
      companyId: 1
    });
  }
}
